import Cookies from 'js-cookie';
import React from 'react';

export const removeAllCookies = () => {
    Object.keys(Cookies.get()).forEach(function (cookie) {
        Cookies.remove(cookie);
    });
};

export const setSessionCookie = (session) => {
    Cookies.remove("sessionSistema");
    Cookies.set("sessionSistema", JSON.stringify(session), { expires: 14 });
};

export const getSessionCookie = () => {
    const sessionCookie = Cookies.get("sessionSistema");
    if (sessionCookie === undefined) {
        return null;
    } else {
        return JSON.parse(sessionCookie);
    }
};

export const SessionContext = React.createContext(getSessionCookie());